// Exports
export default {
	"Notifications": "Notifications_nphym",
	"BottomGroup": "BottomGroup_BY43N",
	"conferencesHistory": "conferencesHistory_yAVsU"
};
